import { Box, Heading, Image, Text } from "@chakra-ui/react";
import i18n from "i18next";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import image from "../assets/images/23.png";
import parse from 'html-react-parser';

// Wrapping Chakra UI's Box component with framer-motion for animation
const MotionBox = motion(Box);

const ServiceBanner = () => {
  const { currentStep } = useSelector((state) => state.location);
  const { service, serviceId, serviceType, dateAndTimeSlot, bookingDetails } =
    useSelector((state) => state.booking);

  useEffect(() => {
    console.log(
      currentStep,
      // "service, serviceId",
      // service,
      // serviceId,
      // serviceType,
      // dateAndTimeSlot,
      // bookingDetails
    );
  }, [currentStep]);

  return (
    <Box
      position="relative"
      width="100%"
      overflow="hidden"
      mb={4}
      borderRadius="md" // Matching rounded corners with cards
      boxShadow="lg" // Adding subtle shadow
    >
      {/* Image Component with Subtle Zoom Animation */}
      <MotionBox
        initial={{ scale: 1.05 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2, ease: "easeInOut" }}
        width="100%"
        height={{ base: "35vh", md: "40vh" }} // Reduced height for compactness
        borderRadius="md" // Ensure rounded corners for image
        overflow="hidden"
      >
        <Image
          src={image}
          alt="Descriptive Alt Text"
          fit="cover"
          width="100%"
          height="100%"
          display="block"
        />
      </MotionBox>

      {/* Subtle Filter Layer */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bg="rgba(0, 0, 0, 0.4)" // Adjusted overlay color
        backdropFilter="blur(2px)" // Subtle blur for readability
        borderRadius="md" // Matching rounded corners
        zIndex={1}
      />
      {/* Text over the Overlay with Fade-In Animation */}
      <MotionBox
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.5 }}
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        zIndex={2}
        color="white"
        textAlign="center"
        padding={{ base: "0.4rem", md: "0.8rem" }} // Compact padding
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        margin="0 auto"
        width={{ base: "90%", md: "75%" }} // Slightly reduced width
      >
        <Heading
          as="h1"
          fontSize={{ base: "sm", md: "lg", lg: "2xl" }} // Adjusted font size
          mb={{ base: 1, md: 2 }} // Reduced margin below the heading          
        >
          {i18n.language === "fr" ? service?.name_fr : service?.name}
        </Heading>
        <Text
          fontSize={{ base: "xs", md: "md", lg: "lg" }} // Reduced text size
          mb={3} // Adjusted margin below the text          
        >
          {parse(i18n.language === "fr"
            ? service?.description_fr || ''
            : service?.description || '')}
        </Text>
      </MotionBox>
    </Box>
  );
};

export default ServiceBanner;
